import {createReducer} from 'redux-act';
import {
  REPORT_TYPES,
  SELF_DELIVERY_DATE_FILTER,
  SELF_DELIVERY_INVOICES_PERIODS
} from 'helpers/constants/reports';
import {
  GENERATE_REPORT,
  EXPORT_REPORTS,
  STOP_EXPORT_REPORTS_LOADING,
  STOP_REPORTS_LOADING,
  SET_REPORT_TYPE,
  CLEAR_REPORT_DATA,
  SET_REPORT_LOCATION,
  SET_REPORTS_DATE_INTERVAL,
  GENERATE_REPORT_SUCCESS,
  SET_DATEPICKER_INDEX,
  SET_REPORT_VISITED_STATISTIC,
  GENERATE_SPECIAL_ORDERS_REPORT,
  GENERATE_SPECIAL_ORDERS_REPORT_SUCCESS,
  SET_TIME_PERIOD,
  SET_SELF_DELIVERY_DATE_FILTER,
  SET_SELF_DELIVERY_INVOICES_PERIOD,
  DOWNLOAD_SELF_DELIVERY_INVOICE_ORDERS,
  DOWNLOAD_SELF_DELIVERY_INVOICE_ORDERS_DONE,
  OPEN_SELF_DELIVERY_INVOICE,
  OPEN_SELF_DELIVERY_INVOICE_DONE,
  SET_SALES_BREAKDOWN_CHANNELS,
  SET_SALES_BREAKDOWN_FULFILLMENTS
} from 'store/reports/action';

const initialState = () => ({
  data: {dataRows: [], reportTypeInner: 2, reportPeriod: []},
  generationLoading: false,
  dataLoading: false,
  exportLoading: false,
  reportType: 2,
  datePickerTabIndex: 3,
  dateRange: ['', ''],
  totalRow: {},
  reportId: '',
  reportLocationId: '',
  // Bumped by every Generate and every clear, so a response can tell it is stale.
  reportRevision: 0,
  quantityData: null,
  stripeIntersected: 'none',
  specialOrdersReportId: null,
  timePeriod: 3,
  selfDeliveryDateFilter: SELF_DELIVERY_DATE_FILTER.ORDER_DATE,
  selfDeliveryInvoicesPeriod: SELF_DELIVERY_INVOICES_PERIODS.LAST_3_MONTHS,
  invoiceOrdersDownloading: null,
  invoiceLinkLoading: null,
  salesBreakdownChannels: [],
  salesBreakdownFulfillments: []
  // skip: 0
  // dataCount: 0
});

const reportsReducer = createReducer(
  {
    [SET_REPORT_VISITED_STATISTIC]: (state, payload) => ({
      ...state,
      generationLoading: false,
      quantityData: payload
    }),
    [GENERATE_REPORT]: (state) => ({
      ...state,
      generationLoading: true,
      reportRevision: state.reportRevision + 1,
      // dataLoading: true,
      // data: [],
      skip: 0
    }),
    [GENERATE_REPORT_SUCCESS]: (state, payload) => {
      const dataRows =
        payload.reportData && payload.reportData.dataRows
          ? payload.reportData.dataRows
          : [];

      // metadata property 'stripe.account.intersection' can has one of three values:
      // 'none' - the location’s Stripe account is used only by the location itself
      // 'several' - the location’s Stripe account is used within multiple locations of a merchant
      // 'merchant-wise' - the location’s Stripe account is used within all the locations of a merchant

      let isStripeIntersected = 'none';

      // Create object for Total row in table:
      let totalObject = {};

      if (state.reportType === 0 || state.reportType === 9) {
        totalObject = payload.totalSummary;
        // let failedTransactions = 0;
        // dataRows.forEach((report) => {
        //   report.payouts.forEach((payout) => {
        //     if (payout.status && payout.status === 'failed') {
        //       failedTransactions += 1;
        //     }
        //   });
        // });
        // totalObject.payoutStatus = !!failedTransactions;
      }

      if (state.reportType === 2) {
        totalObject.status = !!dataRows.find((el) => el.status === 'failed');

        totalObject.amount = dataRows.reduce((accumulator, current) => {
          return (
            accumulator +
            (current.status !== 'failed' && current.status !== 'canceled'
              ? current.amount
              : 0)
          );
        }, 0);
      }

      if (
        state.reportType === 5 ||
        state.reportType === 8 ||
        state.reportType === 9
      ) {
        totalObject = payload.totalSummary;
      }

      if (state.reportType === 3) {
        // Self Delivery Summary - use totalRow from payload
        totalObject = payload.totalRow || {};
      }

      if (state.reportType === REPORT_TYPES.SALES_BREAKDOWN_SUMMARY) {
        totalObject = payload.totalSummary || {};
      }

      if (state.reportType === REPORT_TYPES.SELF_DELIVERY_INVOICES) {
        // Self Delivery Invoices - no total row
        totalObject = {};
      }

      if (payload.metadata && state.reportType === 2) {
        const stripeFlag = payload.metadata.filter(
          (obj) => obj.key === 'stripe.account.intersection'
        );
        if (stripeFlag.length > 0) {
          isStripeIntersected = stripeFlag[0].value;
        }
      }

      return {
        ...state,
        totalRow: totalObject,
        reportId: payload.reportId,
        data: payload.reportData,
        stripeIntersected: isStripeIntersected
      };
    },
    // [GET_REPORTS]: (state) => ({
    //   ...state,
    //   data: []
    //   // dataLoading: true
    // }),
    // [GET_REPORTS_SUCCESS]: (state, payload) => {
    //   return {
    //     ...state,
    //     // data: payload.data.value,
    //     data: payload.data,
    //     generationLoading: false,
    //     dataLoading: false
    //     // dataCount: payload.data['@odata.count']
    //   };
    // },
    [EXPORT_REPORTS]: (state) => ({
      ...state,
      exportLoading: true
    }),
    [STOP_EXPORT_REPORTS_LOADING]: (state) => ({
      ...state,
      exportLoading: false
    }),
    [STOP_REPORTS_LOADING]: (state) => ({
      ...state,
      data: {dataRows: [], reportTypeInner: 2, reportPeriod: []},
      generationLoading: false,
      dataLoading: false
    }),
    [SET_REPORTS_DATE_INTERVAL]: (state, payload) => {
      return {
        ...state,
        dateRange: payload
      };
    },
    [SET_REPORT_TYPE]: (state, payload) => {
      return {
        ...state,
        reportType: payload
      };
    },
    // Drops the generated report, so a type switch does not leave the previous
    // report's rows on screen under the new title until Generate is clicked.
    // A request still loading no longer applies, so loading stops here too.
    [CLEAR_REPORT_DATA]: (state) => ({
      ...state,
      data: {dataRows: [], reportTypeInner: state.reportType, reportPeriod: []},
      totalRow: {},
      reportId: '',
      specialOrdersReportId: null,
      stripeIntersected: 'none',
      reportLocationId: '',
      generationLoading: false,
      reportRevision: state.reportRevision + 1
    }),
    // The location the stored report was generated for, so the Reports page can
    // drop it once the merchant switches to another location.
    [SET_REPORT_LOCATION]: (state, payload) => ({
      ...state,
      reportLocationId: payload
    }),
    [SET_DATEPICKER_INDEX]: (state, payload) => {
      return {
        ...state,
        datePickerTabIndex: payload
      };
    },
    [GENERATE_SPECIAL_ORDERS_REPORT]: (state) => {
      return {
        ...state,
        generationLoading: true,
        reportRevision: state.reportRevision + 1
      };
    },
    [GENERATE_SPECIAL_ORDERS_REPORT_SUCCESS]: (state, payload) => {
      return {
        ...state,
        specialOrdersReportId: payload,
        generationLoading: false,
        data: {dataRows: [], reportTypeInner: 2, reportPeriod: []},
        totalRow: {},
        reportId: '',
        quantityData: null,
        stripeIntersected: 'none'
      };
    },
    [SET_TIME_PERIOD]: (state, payload) => {
      return {
        ...state,
        timePeriod: payload
      };
    },
    [SET_SELF_DELIVERY_DATE_FILTER]: (state, payload) => ({
      ...state,
      selfDeliveryDateFilter: payload
    }),
    [SET_SELF_DELIVERY_INVOICES_PERIOD]: (state, payload) => ({
      ...state,
      selfDeliveryInvoicesPeriod: payload
    }),
    [DOWNLOAD_SELF_DELIVERY_INVOICE_ORDERS]: (state, payload) => ({
      ...state,
      invoiceOrdersDownloading: payload.rowKey
    }),
    [DOWNLOAD_SELF_DELIVERY_INVOICE_ORDERS_DONE]: (state) => ({
      ...state,
      invoiceOrdersDownloading: null
    }),
    [OPEN_SELF_DELIVERY_INVOICE]: (state, payload) => ({
      ...state,
      invoiceLinkLoading: payload.rowKey
    }),
    [OPEN_SELF_DELIVERY_INVOICE_DONE]: (state) => ({
      ...state,
      invoiceLinkLoading: null
    }),
    [SET_SALES_BREAKDOWN_CHANNELS]: (state, payload) => {
      return {
        ...state,
        salesBreakdownChannels: payload || []
      };
    },
    [SET_SALES_BREAKDOWN_FULFILLMENTS]: (state, payload) => {
      return {
        ...state,
        salesBreakdownFulfillments: payload || []
      };
    }
    // [REPORTS_PAGINATE]: (state, payload) => {
    //   return {
    //     ...state,
    //     skip: payload
    //   };
    // }
  },
  initialState()
);

export default reportsReducer;
